/* EditSnapshotViewRenderer.js */

"use strict";

const InputTextControl = require("@gluenetworks/steve_ui_core").Control.Textfield.InputText;
const ButtonControl = require("@gluenetworks/steve_ui_core").Control.Action.Button;

class EditSnapshotViewRenderer {
    constructor(model) {
        this._model = model;
        this._rootElem = document.createElement("edit-snapshot-view-gl");
        this._rootElem.component = this._model;

        this._title = document.createElement("h2");
        this._title.classList.add("title");

        this._fieldContainer = document.createElement("div");
        this._fieldContainer.classList.add("field-container");
        // this._label = document.createElement("label");
        // this._label.innerHTML = "Name";
        this._textfield = new InputTextControl({
            placeholder: "Enter a name for the snapshot"
        });
        // this._fieldContainer.appendChild(this._label);
        this._fieldContainer.appendChild(this._textfield.renderer.rootElement);

        this._rootElem.appendChild(this._title);
        this._rootElem.appendChild(this._fieldContainer);

        this._save = new ButtonControl({
            label: "Confirm",
            darkTheme: true,
            active: true,
            disabled: true
        });

        this._cancel = new ButtonControl({
            label: "Cancel",
            darkTheme: true
        });

        this._setTitle(this._model._captureTime);
        this._setDescription(this._model._description);

        this._onSaveButtonClick = this._onSaveButtonClick.bind(this);
        this._buttonContainer = document.createElement("button-container");
        this._buttonContainer.appendChild(this._cancel.renderer.rootElement);
        this._buttonContainer.appendChild(this._save.renderer.rootElement);
        this._rootElem.appendChild(this._buttonContainer);

        this._registerListeners();
        // this._registerViewActions();

        this.render();
    }
    /********************************************/
    /* START PRIVATE COMPONENT RENDERER METHODS */
    /********************************************/
    _shutdown() {
        let promiseArray = [];
        this._unregisterListeners();
        promiseArray.push(
            this._textfield.shutdown().then(() => {
                this._textfield = undefined;
            })
        );
        promiseArray.push(
            this._save.shutdown().then(() => {
                this._save = undefined;
            })
        );
        promiseArray.push(
            this._cancel.shutdown().then(() => {
                this._cancel = undefined;
            })
        );

        this._model = undefined;
        this._rootElem.remove();
        this._rootElem = undefined;
        this._title = undefined;
        this._fieldContainer = undefined;
        this._label = undefined;
        this._title = undefined;

        return Promise.all(promiseArray);
    }
    // _registerViewActions() {
    //     this._model.gameEditor.addViewAction({
    //         type: "normal",
    //         displayName: "Save",
    //         name: "cancel",
    //         handler: this._onSaveButtonClick
    //     });
    // }
    _registerListeners() {
        this._textfield.on("UserValue", (this._onUserValue = this._onUserValue.bind(this)));

        this._save.on("UserClick", this._onSaveButtonClick);
        this._cancel.on("UserClick", (this._onCancelButtonClick = this._onCancelButtonClick.bind(this)));
    }
    _unregisterListeners() {
        this._textfield.removeAllListeners("UserValue");
        this._save.removeAllListeners("UserClick");
        this._cancel.removeAllListeners("UserClick");
    }
    /*******************************************/
    /* END PRIVATE COMPONENT RENDERER METHODS  */
    /* START PUBLIC COMPONENT RENDERER METHODS */
    /*******************************************/
    /**
     * Stateless method to completely rebuild this component from the _rootElem down.
     * @returns {Promise} An ES6 promise that lets the caller know when the component has finished rendering. If a non
     * Promise is returned the caller will assume the Renderer has completed rendering.
     */
    render() {
        let prom = new Promise((resolve /*,reject*/) => {
            // this._setDeviceConfigurationEntity(this._model.deviceConfigurationEntity);
            resolve();
        });
        return prom;
    }
    get rootElement() {
        return this.getRootElement();
    }
    getRootElement() {
        return this._rootElem;
    }
    get model() {
        return this.getModel();
    }
    getModel() {
        return this._model;
    }
    /*******************************************/
    /* END COMPONENT RENDERER METHODS */
    /* START HANDLER METHODS */
    /*******************************************/

    _onSaveButtonClick() {
        // this._model.deviceConfigurationEntity.setDescription(this._textfield.value);
        // this._model.deviceConfigurationEntity.update();
        return this._model.resolve(this._textfield.value);
    }

    _onCancelButtonClick() {
        this._model.cancelAction();
    }

    _onUserValue(val) {
        if (val !== this._model._description) {
            this._save.setDisabled(false);
        } else {
            this._save.setDisabled(true);
        }
    }

    /*******************************************/
    /* END HANDLER METHODS */
    /* START PRIVATE API METHODS */
    /*******************************************/

    _setTitle(capturedTime) {
        let snapshotIndicator = "";
        if (typeof capturedTime === "string") {
            snapshotIndicator = capturedTime;
        } else {
            let date = new Date(capturedTime),
                datelocale = date.toLocaleDateString(),
                timelocale = date.toLocaleTimeString();
            snapshotIndicator = datelocale + " " + timelocale;
        }
        this._title.innerHTML = `Edit - Name of Snapshot captured on ${snapshotIndicator}`;
    }

    _setDescription(description) {
        this._textfield.value = description;
    }

    /*******************************************/
    /*  END PRIVATE API METHODS */
    /*******************************************/
}

module.exports = EditSnapshotViewRenderer;
